import { generateMockMatterPropertyDamagePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterPropertyDamage } from "@/lib/data/react-query/matters/matter-property-damage";
import { useCallback } from "react";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterPropertyDamage = () => {
  const createPropertyDamage = useCreateMatterPropertyDamage();

  const createMockMatterPropertyDamage = useCallback(
    async (
      matterId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createPropertyDamage.mutateAsync(
          generateMockMatterPropertyDamagePayload(matterId, overrides),
        ),
      ),
    [createPropertyDamage],
  );

  return {
    createMockMatterPropertyDamage,
    mutation: createPropertyDamage,
  };
};
